'use strict';

angular.module('shiftTraderApp')
    .directive('saIntervalOverlayBar', function ($compile, $timeout, saViewShiftHourWidthInt, $interval,
                                                 zIndexManageWorkPeriodsMax,
                                                 zIndexManageWorkPeriodsDeptInterval) {
      var barTemplate = '<div class="bar_hour_overlay_interval" data-ng-bind="::barLabel"></div>';
      var tooltipTemplate = '<div class="interval_overlay_bar_tooltip" sa-interval-information-area="intervalObj" ctrl="saWideWorkPeriodViewCtrl" department="dept"></div>';
      return {
        restrict: 'A',
        scope: true,
        require: '^saWideWorkPeriodView',
        compile: function (tElem, tAttrs) {
          var barTemplateLinker = $compile(barTemplate);
          var tooltipTemplateLinker = $compile(tooltipTemplate);

          var openDelay = 500;

          return function link (scope, elem, attrs, ctrl) {
            scope.saWideWorkPeriodViewCtrl = ctrl;
            var tooltipOpenState = false;
            var tooltip;
            var barElement;
            var tappedOpen;
            var tooltipTimeout;

            var positionTooltip = function () {
              var tooltipIndicatorArrow = $(tooltip).find('.sa_interval_up_arrow');
              var barElementLeftPos = $(barElement).position().left;
              var barElementWidth = $(barElement).outerWidth();
              var tooltipWidth = $(tooltip).width();
              var tooltipIndicatorArrowLeftPos = 60;
              var idealTooltipLeftPos = barElementLeftPos + ((barElementWidth - tooltipWidth) / 2.0);
              var newTooltipLeftPos = _.clone(idealTooltipLeftPos);

              if (idealTooltipLeftPos < 0) {
                tooltipIndicatorArrowLeftPos += idealTooltipLeftPos;
                newTooltipLeftPos = 0;
              }

              if ((idealTooltipLeftPos + tooltipWidth) >= (saViewShiftHourWidthInt * 36)) {
                tooltipIndicatorArrowLeftPos += (idealTooltipLeftPos + tooltipWidth - saViewShiftHourWidthInt * 36);
                newTooltipLeftPos = saViewShiftHourWidthInt * 36 - tooltipWidth;
              }

              tooltip.css({
                top: 26 + 'px',
                left: newTooltipLeftPos + 'px'
              });

              // change the position of the black arrow that indicates which interval we're inspecting
              tooltipIndicatorArrow.css('left', tooltipIndicatorArrowLeftPos);
            };

            var hoverIn = function () {
              if (barElement) {
                var element = $(barElement);
                if (element && element.length > 0) {
                  element.addClass('hovering');
                }
              }
              if (!tooltipOpenState) {
                toggleTooltipOpen();
              }
            };

            var hoverOut = function () {
              $(barElement).removeClass('hovering');

              if (!tappedOpen) {
                closeTooltip(true);
              }

            };

            var openTooltip = function () {
              if (!tooltipTimeout) {
                tooltipTimeout = $timeout(function() {
                  tooltip = tooltipTemplateLinker(scope, function () {});

                  var theZIndex = scope.dept ? scope.dept._zIndexStart: zIndexManageWorkPeriodsMax;
                  tooltip.css({ top: 0, left: 0, display: 'block', 'z-index': theZIndex });
                  elem.append( tooltip );
                  positionTooltip();
                  scope.$digest();
                  tooltipOpenState = true;
                  $timeout(function() {
                    if (tooltip) {
                      tooltip.addClass('active');
                    }
                  }, 0);

                }, openDelay);
              }
            };

            var closeTooltip = function (animate) {
                tooltipOpenState = false;
                $timeout.cancel(tooltipTimeout);
                tooltipTimeout = undefined;
              if (tooltip) {
                if (animate) {
                  tooltip.removeClass('active');
                  $timeout(function() {
                    if (tooltip) {
                      tooltip.remove();
                    }
                    tooltip = null;
                  }, 300);
                } else {
                  tooltip.remove();
                  tooltip = null;
                }
              }

            };

            var toggleTooltipOpen = function () {
              if (!tooltipOpenState) {
                openTooltip();
              } else {
                closeTooltip(true);
              }
            };

            $(elem).bind('mousedown touchdown', function (event) {
              if (tooltipOpenState) {
                tappedOpen = false;
              } else {
                tappedOpen = true;
              }

              toggleTooltipOpen();
              event.stopPropagation();
            });

            if (parseFloat(scope.intervalObj.styling.width.slice(0, -1)) >= 1.35) {
              scope.barLabel = scope.intervalObj.count;
            }

            barElement = barTemplateLinker(scope, function() {});
            angular.element(barElement).css(scope.intervalObj.styling);

            //using the department index to figure out what the z-index of the little bars should be

            var theZIndex = scope.dept ? scope.dept._zIndexStart: zIndexManageWorkPeriodsMax;
            angular.element(barElement).css('z-index', theZIndex);

            $(barElement).hover(hoverIn, hoverOut);
            elem.append(barElement);


            // Make sure tooltip is destroyed and removed.
            scope.$on('$destroy', function onDestroyTooltip() {
              closeTooltip(false);
              tappedOpen = false;
            });
          };
        }
      }
    });
